import { useEffect, useState } from "react";
import { useApi } from "@/api/useApi";

export function usePlatformAdmin() {
  const api = useApi();
  const [isPlatformAdmin, setIsPlatformAdmin] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/admin/check")
      .then((r) => setIsPlatformAdmin(!!r.data?.is_platform_admin))
      .catch(() => setIsPlatformAdmin(false))
      .finally(() => setLoaded(true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { isPlatformAdmin, loaded };
}
